<script>
export default {
  name: "Employee"
}
</script>


<template>
  <div class="employee">
    <h1>Управление пользователями</h1>
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <button class="nav-link active" id="nav-admin-tab" data-bs-toggle="tab" data-bs-target="#admin" type="button"
                role="tab" aria-controls="admin" aria-selected="true">Сотрудники
        </button>
        <button class="nav-link" id="nav-admin-tab" data-bs-toggle="tab" data-bs-target="#client" type="button"
                role="tab" aria-controls="client" aria-selected="true">Клиенты
        </button>
        <button class="nav-link" id="nav-admin-tab" data-bs-toggle="tab" data-bs-target="#driver" type="button"
                role="tab" aria-controls="driver" aria-selected="true">Водители
        </button>
        <button class="nav-link" id="nav-admin-tab" data-bs-toggle="tab" data-bs-target="#wait_confirm" type="button"
                role="tab" aria-controls="wait_confirm" aria-selected="true">Ожидают подтверждения
        </button>
      </div>
    </nav>
    <div class="tab-content">
      <div class="tab-pane fade show active" id="admin" role="tabpanel" aria-labelledby="admin">
        <table class="table table-striped caption-top">
          <thead>
          <tr>
            <th scope="col">ФИО</th>
            <th scope="col">Логин</th>
            <th scope="col">Телеграм ID</th>
            <th scope="col">Телефон</th>
            <th scope="col">Роли</th>
            <th scope="col">Подтвержден</th>
            <th scope="col">Уведомления</th>
            <th scope="col">Отдел</th>
            <th scope="col">Оклад</th>
            <th scope="col">Фиксируется ОФ</th>
            <th scope="col">Другие выплаты</th>
            <th scope="col">Примечание</th>
            <th scope="col">Изменить</th>
            <th scope="col">Удалить</th>
          </tr>
          </thead>
          <tbody id="my-table">
          <template v-for="(user, id) in usersInfo" :key="id">
            <tr v-if="user.role.code === 'ROLE_BUH'
            || user.role.code === 'ROLE_MANAGER' || user.role.code === 'ROLE_ADMIN'" class="mt-6">
              <td>{{ user.fullName }}</td>
              <td>{{ user.login }}</td>
              <td>{{ user.chatId }}</td>
              <td>{{ user.phone }}</td>
              <td>{{ user.role.name }}</td>
              <td v-if="user.confirmed === true">Да</td>
              <td v-else>Нет</td>
              <td v-if="user.confirmedNotification === true">Да</td>
              <td v-else>Нет</td>
              <template v-if="user.employee != null">
                <td>{{ user.employee.department }}</td>
                <td>{{ user.employee.salary }}</td>
                <td>{{ user.employee.fixedPart }}</td>
                <td>{{ user.employee.otherPayments }}</td>
                <td>{{ user.employee.note }}</td>
              </template>
              <template v-else>
                <td>Необходимо заполнить данные о сотруднике</td>
                <td>Необходимо заполнить данные о сотруднике</td>
                <td>Необходимо заполнить данные о сотруднике</td>
                <td>Необходимо заполнить данные о сотруднике</td>
                <td>Необходимо заполнить данные о сотруднике</td>
              </template>
              <td>
                <UiButton @click="getUserById(user.id)" bgColor="blue" :isSmall=true data-bs-toggle="modal"
                          data-bs-target="#exampleModal">
                  Изменить
                </UiButton>
              </td>
              <td>
                <UiButton @click="getUserById(user.id)" bgColor="red" :isSmall=true data-bs-toggle="modal"
                          data-bs-target="#modal">
                  Удалить
                </UiButton>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
      <div class="tab-pane fade show" id="client" role="tabpanel" aria-labelledby="client">
        <table class="table table-striped caption-top">
          <thead>
          <tr>
            <th scope="col">ФИО</th>
            <th scope="col">Логин</th>
            <th scope="col">Телеграм ID</th>
            <th scope="col">Телефон</th>
            <th scope="col">Роли</th>
            <th scope="col">Подтвержден</th>
            <th scope="col">Уведомления</th>
            <th scope="col">Изменить</th>
            <th scope="col">Удалить</th>
          </tr>
          </thead>
          <tbody id="my-table">
          <template v-for="(user, id) in usersInfo" :key="id">
            <tr v-if="user.role.code === 'ROLE_CLIENT'" class="mt-6">
              <!--            <div v-if="user.role.code === 'ROLE_USER'">-->
              <td>{{ user.fullName }}</td>
              <td>{{ user.login }}</td>
              <td>{{ user.chatId }}</td>
              <td>{{ user.phone }}</td>
              <td>{{ user.role.name }}</td>
              <td v-if="user.confirmed === true">Да</td>
              <td v-else>Нет</td>
              <td v-if="user.confirmedNotification === true">Да</td>
              <td v-else>Нет</td>
              <td>
                <UiButton @click="getUserById(user.id)" bgColor="blue" :isSmall=true data-bs-toggle="modal"
                          data-bs-target="#exampleModal">
                  Изменить
                </UiButton>
              </td>
              <td>
                <UiButton @click="getUserById(user.id)" bgColor="red" :isSmall=true data-bs-toggle="modal"
                          data-bs-target="#modal">
                  Удалить
                </UiButton>
              </td>
              <!--            </div>-->
            </tr>
          </template>
          </tbody>
        </table>
      </div>
      <div class="tab-pane fade show" id="driver" role="tabpanel" aria-labelledby="driver">
        <table class="table table-striped caption-top">
          <thead>
          <tr>
            <th scope="col">ФИО</th>
            <th scope="col">Логин</th>
            <th scope="col">Телеграм ID</th>
            <th scope="col">Телефон</th>
            <th scope="col">Роли</th>
            <th scope="col">Подтвержден</th>
            <th scope="col">Уведомления</th>
            <th scope="col">Изменить</th>
            <th scope="col">Удалить</th>
          </tr>
          </thead>
          <tbody id="my-table">
          <template v-for="(user, id) in usersInfo" :key="id">
            <tr v-if="user.role.code === 'ROLE_DRIVER'" class="mt-6">
              <td>{{ user.fullName }}</td>
              <td>{{ user.login }}</td>
              <td>{{ user.chatId }}</td>
              <td>{{ user.phone }}</td>
              <td>{{ user.role.name }}</td>
              <td v-if="user.confirmed === true">Да</td>
              <td v-else>Нет</td>
              <td v-if="user.confirmedNotification === true">Да</td>
              <td v-else>Нет</td>
              <td>
                <UiButton @click="getUserById(user.id)" bgColor="blue" :isSmall=true data-bs-toggle="modal"
                          data-bs-target="#exampleModal">
                  Изменить
                </UiButton>
              </td>
              <td>
                <UiButton @click="getUserById(user.id)" bgColor="red" :isSmall=true data-bs-toggle="modal"
                          data-bs-target="#modal">
                  Удалить
                </UiButton>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
      <div class="tab-pane fade show" id="wait_confirm" role="tabpanel" aria-labelledby="wait_confirm">
        <table class="table table-striped caption-top">
          <thead>
          <tr>
            <th scope="col">ФИО</th>
            <th scope="col">Логин</th>
            <th scope="col">Телеграм ID</th>
            <th scope="col">Телефон</th>
            <th scope="col">Роли</th>
            <th scope="col">Подтвержден</th>
            <th scope="col">Уведомления</th>
            <th scope="col">Изменить</th>
            <th scope="col">Удалить</th>
          </tr>
          </thead>
          <tbody id="my-table">
          <template v-for="(user, id) in usersInfo" :key="id">
            <tr v-if="user.role.code === 'ROLE_USER'" class="mt-6">
              <td>{{ user.fullName }}</td>
              <td>{{ user.login }}</td>
              <td>{{ user.chatId }}</td>
              <td>{{ user.phone }}</td>
              <td>{{ user.role.name }}</td>
              <td v-if="user.confirmed === true">Да</td>
              <td v-else>Нет</td>
              <td v-if="user.confirmedNotification === true">Да</td>
              <td v-else>Нет</td>
              <td>
                <UiButton @click="getUserById(user.id)" bgColor="blue" :isSmall=true data-bs-toggle="modal"
                          data-bs-target="#exampleModal">
                  Изменить
                </UiButton>
              </td>
              <td>
                <UiButton @click="getUserById(user.id)" bgColor="red" :isSmall=true data-bs-toggle="modal"
                          data-bs-target="#modal">
                  Удалить
                </UiButton>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>

      <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Редактировать работника</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Закрыть"></button>
            </div>
            <div class="modal-body">
              <form>
                <v-container>
                  <div class="userEdit">
                    <UiInput v-model="user.fullName" class="mb-4" label="ФИО"/>
                    <UiInput v-model="user.login" class="mb-4" label="Логин"/>
                    <UiInput v-model="user.chatId" class="mb-4" disabled="disabled" label="Телграм ID"/>
                    <UiInput v-model="user.phone" class="mb-4" disabled="disabled" label="Телефон"/>
                    <v-select
                        v-model="userForSave.role"
                        variant="outlined"
                        label="Роль"
                        class="mb-2"
                        color="active"
                        :items="Object.keys(list)"
                        hide-details
                    ></v-select>
                    <v-select
                        v-model="userForSave.confirmed"
                        variant="outlined"
                        color="active"
                        label="Подверждение"
                        :items="['Да', 'Нет']"
                    ></v-select>
                    <v-select
                        v-model="userForSave.confirmedNotification"
                        variant="outlined"
                        color="active"
                        label="Уведомления"
                        :items="['Да', 'Нет']"
                    ></v-select>
                    <template v-if="user.employee != null">
                      <UiInput v-model="user.employee.department" class="mb-4" label="Отдел"/>
                      <UiInput v-model="user.employee.salary" class="mb-4" label="Оклад"/>
                      <UiInput v-model="user.employee.fixedPart" class="mb-4" label="Фиксируется ОФ"/>
                      <UiInput v-model="user.employee.otherPayments" class="mb-4" label="Другие выплаты"/>
                      <UiInput v-model="user.employee.note" class="mb-4" label="Примечание"/>
                    </template>
                    <template v-else>
                      <UiInput v-model="employee.department" class="mb-4" label="Отдел"/>
                      <UiInput v-model="employee.salary" class="mb-4" label="Оклад"/>
                      <UiInput v-model="employee.fixedPart" class="mb-4" label="Фиксируется ОФ"/>
                      <UiInput v-model="employee.otherPayments" class="mb-4" label="Другие выплаты"/>
                      <UiInput v-model="employee.note" class="mb-4" label="Примечание"/>
                    </template>
                  </div>
                </v-container>
                <UiButton @click="patchUserInfo" bgColor="blue" data-bs-dismiss="modal">
                  Применить
                </UiButton>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="modal" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="modalLabel">Удалить пользователя?</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Закрыть"></button>
            </div>
            <div class="modal-body">
              <form>
                <v-container>
                  <div class="userEdit">
                    <UiInput v-model="user.fullName" class="mb-4" disabled="disabled" label="ФИО"/>
                    <UiInput v-model="user.login" class="mb-4" disabled="disabled" label="Логин"/>
                    <UiInput v-model="user.chatId" class="mb-4" disabled="disabled" label="Телграм ID"/>
                    <UiInput v-model="user.phone" class="mb-4" disabled="disabled" label="Телефон"/>
                    <v-select
                        v-model="userForSave.role"
                        :disabled="true"
                        variant="outlined"
                        label="Роль"
                        class="mb-2"
                        color="active"
                        :items="Object.keys(list)"
                        hide-details
                    ></v-select>
                    <v-select
                        v-model="userForSave.confirmed"
                        :disabled="true"
                        variant="outlined"
                        color="active"
                        label="Подверждение"
                        :items="['Да', 'Нет']"
                    ></v-select>
                    <v-select
                        v-model="userForSave.confirmedNotification"
                        :disabled="true"
                        variant="outlined"
                        color="active"
                        label="Уведомления"
                        :items="['Да', 'Нет']"
                    ></v-select>
                  </div>
                </v-container>
                <UiButton @click="deleteUserAdmin" bgColor="red" data-bs-dismiss="modal">
                  Удалить
                </UiButton>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {reactive, ref, onMounted} from 'vue'
import {getUser, getUsers, patchUser, deleteUser} from '@/API/ways/admin'

import UiButton from '@/components/ui-kit/UiButton.vue'
import UiInput from '@/components/ui-kit/UiInput.vue'
import Arr from '@/helpers/roles'


const list = ref(Arr)
let usersInfo = ref({})
let user = reactive({
  id: null,
  chatId: null,
  confirmed: false,
  confirmedNotification: false,
  fullName: '',
  role: null,
  employee: null,
  login: '',
  name: '',
  phone: '',
})
let userForSave = reactive({
  confirmed: '',
  confirmedNotification: '',
  role: ''
})
let employee = reactive({
  department: '',
  salary: '',
  fixedPart: '',
  otherPayments: '',
  note: ''
})

onMounted(async () => {
  setTimeout(() => {
    document.body.style.overflow = 'auto';
  }, 500);
  await getUsers().then((response) => {
    usersInfo.value = response.data.object;

    console.log(usersInfo.value)
  })
})

async function getUserById(id) {
  await getUser(id).then((response) => {
    try {
      let data = response.data.object
      console.log(data)
      user.id = data.id
      user.fullName = data.fullName
      user.login = data.login
      user.name = data.name
      user.chatId = data.chatId
      user.confirmed = data.confirmed
      user.confirmedNotification = data.confirmedNotification
      user.role = data.role
      user.employee = data.employee
      user.phone = data.phone
      userForSave.confirmed = user.confirmed ? 'Да' : 'Нет'
      userForSave.confirmedNotification = user.confirmedNotification ? 'Да' : 'Нет'
      userForSave.role = user.role.name
    } catch (e) {
      console.error('error:', e)
    }
  })
}

async function patchUserInfo() {
  user.confirmed = userForSave.confirmed === 'Да'
  user.confirmedNotification = userForSave.confirmedNotification === 'Да'
  user.role = list.value[userForSave.role]
  if (employee != null) {
    user.employee = employee
  }
  await patchUser(user)
}

async function deleteUserAdmin() {
  await deleteUser(user.id)
}

</script>

<style scoped>

</style>